export enum EntityType {
    Patient = 1,
    Prescriber = 2,
    Insurance = 3,
    Pharmacy = 4,
}

export enum IVRVendor
{
    NexIPTel = "1",
    Vow = "2",
    Finner = "3"
}